// extracted by mini-css-extract-plugin
export var grabbing_wrap = "Navigation-module--grabbing_wrap--H9j4c";
export var grabbing = "Navigation-module--grabbing--Aj74t";
export var drag = "Navigation-module--drag--lVEwT";
export var inline = "Navigation-module--inline--3cBq8";
export var navigation = "Navigation-module--navigation--6cMXu";
export var navigation_absolute = "Navigation-module--navigation_absolute--57BUU";
export var development = "Navigation-module--development--KiC6b";